import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useAppStoreDispatch, useAppStoreSelector } from '../../../store';
import { cleanMessage } from '../store/toast';

const ToastEl = () => {
  const toastState = useAppStoreSelector((state) => state.toast);
  const dispatch = useAppStoreDispatch();
  const { isError, isShow, message } = toastState.data;

  const onToastCloseHandler = () => {
    dispatch(cleanMessage());
  };

  return (
    <Snackbar
      open={isShow}
      autoHideDuration={3000}
      onClose={onToastCloseHandler}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{ zIndex: 3000 }}
    >
      <Alert
        onClose={onToastCloseHandler}
        severity={isError ? 'error' : 'success'}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default ToastEl;
